<script>import Seo from "./seo.svelte";
export let siteName;
export let siteUrl;
export let language = "en_GB";
export let defaultTitle;
export let defaultMetaDescription;
export let defaultDate = (/* @__PURE__ */ new Date()).toISOString();
export let settings = {
  canonical: true,
  twitter: true,
  openGraph: true,
  schemaOrg: true
};
export let openGraph = null;
export let faviconHtml = null;
export let pageSeoData;
</script>

<Seo
  {siteName}
  {siteUrl}
  {language}
  {defaultTitle}
  {defaultMetaDescription}
  {defaultDate}
  {settings}
  {openGraph}
  {faviconHtml}
  {...pageSeoData}
/>
